import { useCallback, useState } from "react";

const EMPTY: ReadonlySet<string> = new Set();

/**
 * Seleção que se apaga quando o filtro muda, no molde do `useResettingPage`.
 *
 * A seleção fica guardada junto da chave do filtro em que foi feita. Quando a
 * chave muda, o próprio render zera o estado, sem precisar de efeito: só
 * esconder a seleção pela chave fazia a seleção antiga voltar quando o filtro
 * voltava ao anterior, e o lote seguinte levava objeto que a pessoa já não via
 * marcado. O `set` fica preso à chave de quando foi criado: uma busca lenta que
 * termina depois de o filtro mudar grava na chave velha, e o render seguinte a
 * descarta.
 */
export function useResettingSelection(
  filterKey: string,
): [ReadonlySet<string>, (next: ReadonlySet<string>) => void] {
  const [state, setState] = useState<{ key: string; names: ReadonlySet<string> }>({
    key: filterKey,
    names: EMPTY,
  });
  if (state.key !== filterKey) {
    setState({ key: filterKey, names: EMPTY });
  }
  const names = state.key === filterKey ? state.names : EMPTY;
  const setNames = useCallback(
    (next: ReadonlySet<string>) => setState({ key: filterKey, names: next }),
    [filterKey],
  );
  return [names, setNames];
}
